/* eslint-disable max-len */
/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { IPReputationDBListPageContainerComponent } from 'ng/modules/ip-reputation-db';

import { WafApplicationRulesListComponent } from
    'ng/modules/waf/components/waf-application-rules-list/waf-application-rules-list.component';

import { WafProfileListComponent } from
    'ng/modules/waf/components/waf-profile-list/waf-profile-list.component';

import { AuthProfileListPageComponent } from
    'ng/modules/security/components/auth-profile-page/auth-profile-page.component';

import { IpAddrGroupListPageComponent } from
    'ng/modules/groups/components/ip-addr-group-page/ip-addr-group-page.component';

import { SslCertificateListComponent }
    from 'ng/modules/security/components/ssl-certificate-list/ssl-certificate-list.component';

import { NodesPageComponent } from
    'ng/modules/cluster/components/nodes-page/nodes-page.component';

import { ErrorPageBodyComponent } from
    'ng/modules/error-page/components/error-page-body/error-page-body.component';

import { ErrorPageProfileListComponent } from
    'ng/modules/error-page/components/error-page-profile-list/error-page-profile-list.component';

import {
    BackupPageComponent,
} from 'ng/modules/system/components';

import {
    UserPageListComponent,
} from 'ng/modules/accounts/components/user-page-list/user-page-list.component';

import { NetworkSecurityPolicyListComponent } from
    'ng/modules/network-security-policy/components/network-security-policy-list/network-security-policy-list.component';

import { HTTPPolicySetListComponent } from 'ng/modules/http-policy-set';
import { CPortalPageComponent } from 'ng/modules/cportal/components/cportal-page';
import { CrashReportsPageComponent } from 'ng/modules/system/components/crash-reports-page';

import { TrafficCloneProfilePageComponent } from
    'ng/modules/traffic-clone-profile/components/traffic-clone-profile-page';

import { VrfContextPageComponent } from 'ng/modules/vrf-context/components/vrf-context-page';

import { BotMappingPageComponent }
    from 'ng/modules/bot/components/bot-mapping-page/bot-mapping-page.component';
import { DnsPolicyListComponent } from
    'ng/modules/dns-policy/components/dns-policy-list/dns-policy-list.component';

import { TrafficCapturePageComponent } from
    'ng/modules/service-engine/components/traffic-capture-page/traffic-capture-page.component';

import { AuthMappingProfilePageComponent } from
    'ng/modules/security/components/auth-mapping-profile-page/auth-mapping-profile-page.component';

import { CertificateManagementListPageComponent } from
    'ng/modules/security/components/certificate-management-list-page/certificate-management-list-page.component';

import { PkiProfileListPageComponent }
    from 'ng/modules/security/components/pki-profile-list-page/pki-profile-list-page.component';

import { DataScriptComponent }
    from 'ng/modules/scripts/components/data-script/data-script.component';

import { ControlScriptComponent }
    from 'ng/modules/scripts/components/control-script/control-script.component';

import { SSOPolicyListComponent }
    from 'ng/modules/sso-policy/components/sso-policy-list/sso-policy-list.component';

import { ProtocolParserScriptComponent }
    from 'ng/modules/scripts/components/protocol-parser-script/protocol-parser-script.component';

import { SslProfileListComponent }
    from 'ng/modules/security/components/ssl-profile-list/ssl-profile-list.component';

import { L4PolicyComponent }
    from 'ng/modules/l4-policy/l4-policy.component';

import { JwtServerProfileComponent }
    from 'ng/modules/security/components/jwt-server-profile/jwt-server-profile.component';
import { HsmGroupListComponent }
    from 'ng/modules/security/components/hsm-group-list/hsm-group-list.component';

import { UserProfileListComponent }
    from 'ng/modules/accounts/components/user-profile-list/user-profile-list.component';

import { StringGroupListComponent }
    from 'ng/modules/groups/components/string-group-list/string-group-list.component';

import { GeoDbListComponent }
    from 'ng/modules/security/components/geo-db-list/geo-db-list.component';

import { BotManagementPolicyListComponent } from
    'ng/modules/bot/components/bot-management-policy-list/bot-management-policy-list.component';

import {
    ServerAutoScalePolicyListPageComponent,
    // eslint-disable-next-line max-len
} from 'ng/modules/auto-scale/components/server-auto-scale-policy-list-page/server-auto-scale-policy-list-page.component';

import {
    LaunchConfigListPageComponent,
} from 'ng/modules/auto-scale/components/launch-config-list-page/launch-config-list-page.component';

import { CustomerProgramComponent } from 'ng/modules/external-services/components/customer-program';

import {
    CSRFPolicyListPageComponent,
    PoolGroupDeploymentPolicyListPageComponent,
    SnmpTrapListPageComponent,
    TechSupportListPageComponent,
    WafCrsListPageComponent,
    UploadHsmPackagesPageComponent,
} from 'router-components/index';

import {
    WebhookListPageComponent,
} from 'ng/modules/webhook/components/webhook-list-page/webhook-list-page.component';

import {
    IcapProfileListPageComponent,
} from 'ng/modules/icap-profile/components/icap-profile-list-page/icap-profile-list-page.component';

import {
    IpamDnsProfileListPageComponent,
} from 'ng/modules/ipam/components/ipam-dns-profile-list-page/ipam-dns-profile-list-page.component';

import {
    CustomIpamDnsProfileListPageComponent,
} from 'ng/modules/ipam/components/custom-ipam-dns-profile-list-page/custom-ipam-dns-profile-list-page.component';

import {
    UserCredentialsListPageComponent,
} from 'ng/modules/cloud-connector-user/components/user-credentials-page/user-credentials-page.component';

import {
    HealthMonitorListPageComponent,
} from 'ng/modules/health-monitor/components/health-monitor-list-page/health-monitor-list-page.component';
import {
    NetworkProfilesListPageComponent,
} from 'ng/modules/network/components/network-profiles-list-page/network-profiles-list-page.component';

import {
    AlertActionsListPageComponent,
} from 'ng/modules/alert/components/alert-actions-list-page/alert-actions-list-page.component';

import {
    RoleListPageComponent,
} from 'ng/modules/accounts/components/role-list-page/role-list-page.component';

import {
    DnsRecordsPageComponent,
} from 'ng/modules/virtual-service/components/dns-records-page/dns-records-page.component';

import {
    NatPolicyListPageComponent,
} from 'ng/modules/nat-policy/components/nat-policy-list-page/nat-policy-list-page.component';

import {
    AnalyticsProfileListPageComponent,
} from 'ng/modules/analytics/components/analytics-profile-list-page/analytics-profile-list-page.component';

import {
    NetworkListPageComponent,
} from 'ng/modules/network/components/network-list-page/network-list-page.component';

import {
    WafPolicyListPageComponent,
} from 'ng/modules/waf/components/waf-policy-list-page/waf-policy-list-page.component';

import {
    VsVipListPageComponent,
} from 'ng/modules/vs-vip/components/vs-vip-list-page/vs-vip-list-page.component';
import {
    AlertConfigListPageComponent,
} from 'ng/modules/alert/components/alert-config-list-page/alert-config-list-page.component';

import { VsLogsPageComponent } from 'ng/modules/vs-logs';

import {
    SEGroupListPageComponent,
} from 'ng/modules/service-engine-group/components/se-group-list-page/se-group-list-page.component';

import {
    ApplicationProfileListPageComponent,
    // eslint-disable-next-line max-len
} from 'ng/modules/application-profile/components/application-profile-list-page/application-profile-list-page.component';

import {
    TenantSettingsPageListComponent,
} from 'ng/modules/accounts/components/tenant-settings-page-list/tenant-settings-page-list.component';

import {
    loadSystemInfo,
    loadedSystemConfigService,
    resolveGslb,
} from 'ng/modules/core/utils/router-resolves.utils';

import {
    PoolGroupListPageComponent,
} from 'ng/modules/pool-group/components/pool-group-list-page/pool-group-list-page.component';

import { UpdatePageComponent }
    from 'ng/modules/update/components/update-page/update-page.component';

import {
    GslbSitesListPageComponent,
} from 'router-components/gslb-sites-list-page/gslb-sites-list-page.component';

import { LicensingPageComponent } from 'ng/modules/licensing/components/licensing-page/licensing-page.component';

import {
    GslbSubdomainsListPageComponent,
} from 'router-components/gslb-subdomains-list-page';

import { UpgradeProfileItem } from 'items/upgrade-profile.item.factory';

import { TechSupportProfileItem } from 'items/tech-support-profile.item.factory';

import * as globalL10n from 'global-l10n';
import {
    AllAlertsListPageComponent,
} from 'router-components/all-alerts-list-page/all-alerts-list-page.component';

import {
    SystemUpdateComponent,
    SegUpdatePageComponent,
} from 'ng/modules/update/components';

import {
    VsListPageComponent,
} from 'ng/modules/virtual-service/components/vs-list-page/vs-list-page.component';
import * as l10n from '../core.l10n';

const { ENGLISH, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

// common params for list pages
const listParams = '?timeframe';
const commonLogParams = [//alerts, events and logs
    'timeframe',
    'orderby',
];

export const logParams = commonLogParams.concat([
    'start',
    'end',
    'asc',
    'search',
    'page_size',
    'filter',
]);

const eventParams = commonLogParams.concat([
    'start',
    'end',
    'search',
    'inclInternal',
    'inclSystemEvents',
]);

const logParamsObject = {};

logParams.forEach(param => logParamsObject[param] = { dynamic: true });

const eventListStateConfig = {
    name: 'events',
    url: `/event?${eventParams.join('&')}`,
    template: '<events-page></events-page>',
    title: globalL10nKeys.eventsLabel,
    data: {
        tfGroup: 'logs',
        hasSidebar: true,
        showTimeframe: true,
    },
    params: {},
};

eventParams.forEach(param => eventListStateConfig.params[param] = { dynamic: true });

const getEventListStateConfig = params => angular.merge({}, eventListStateConfig, params);

const alertListStateConfig = {
    name: 'alerts',
    url: `/alerts?${commonLogParams.join('&')}`,
    template: '<alerts-page></alerts-page>',
    title: globalL10nKeys.alertsLabel,
    data: {
        tfGroup: 'logs',
        showTimeframe: true,
    },
    params: {},
};

commonLogParams.forEach(param => alertListStateConfig.params[param] = { dynamic: true });

const getAlertListStateConfig = params => angular.merge({}, alertListStateConfig, params);

const getInsightsStateConfig = (withoutHeader = false) => {
    const defaultChild = {
        name: 'default',
        url: `${listParams}`,
        views: {
            '': {
                component: 'hsInsights',
            },
        },
    };

    if (!withoutHeader) {
        defaultChild.views.nav = {
            template: '<header></header>',
        };
    }

    return {
        name: 'hs-insights',
        url: '/hs-insights',
        defaultChild: 'default',
        abstract: true,
        templateUrl: 'src/views/details-leaf-page-template.html',
        data: {
            tfGroup: 'insights',
            metricsValueSelector: false,
            timeFrameSelector: false,
        },
        children: [defaultChild],
    };
};

const insightsStateConfigForVS = {
    name: 'hs-insights',
    url: `/hs-insights${listParams}`,
    title: globalL10nKeys.healthLabel,
    component: 'hsInsights',
    data: {
        tfGroup: 'insights',
    },
};

const loadedPulseRegistrationStatus = {
    token: 'loadedPulseRegistrationStatus',
    resolveFn: (cportalService, auth) => {
        if (auth.isPrivilegeAllowed('PERMISSION_ALBSERVICESSTATUS')) {
            return cportalService.loadRegistrationStatus().then(() => cportalService);
        }
    },
    deps: ['CportalService', 'Auth'],
};

const resolveVS = {
    token: 'resolveVS',
    resolveFn: (loadItem, { vsId }, Class) => {
        const args = {
            id: vsId,
            fields: [
                'config',
                'health',
                'alert',
                'faults',
            ],
        };

        return loadItem(args, Class);
    },
    deps: ['loadItem', '$stateParams', 'VirtualService'],
};

const resolvePool = {
    token: 'resolvePool',
    resolveFn: (loadItem, { poolId }, Class) => {
        const args = {
            id: poolId,
            fields: [
                'config',
                'health',
                'alert',
                'faults',
            ],
        };

        return loadItem(args, Class);
    },
    deps: ['loadItem', '$stateParams', 'Pool'],
};

const resolvePoolServer = {
    token: 'resolvePoolServer',
    resolveFn: (loadPoolServer, { poolId, serverId }, pool) => loadPoolServer({
        poolId,
        serverId,
        pool,
    }),
    deps: ['loadPoolServer', '$stateParams', 'resolvePool'],
};

const resolveCloud = {
    token: 'resolveCloud',
    resolveFn: (loadCloud, { cloudId }) => loadCloud(cloudId),
    deps: ['loadCloud', '$stateParams'],
};

const resolveGslbService = {
    token: 'resolveGslbService',
    resolveFn: (loadItem, { gslbServiceId }, gslb, GSLBService) => {
        const params = { id: gslbServiceId };

        if (gslb) {
            params.gslb = gslb;
        }

        return loadItem(params, GSLBService);
    },
    deps: ['loadItem', '$stateParams', 'resolveGslb', 'GSLBService'],
};

const resolveUpgradeProfile = {
    token: 'resolveUpgradeProfile',
    resolveFn: (loadItem, UpgradeProfileItem) => {
        return loadItem({ id: 'default' }, UpgradeProfileItem);
    },
    deps: ['loadItem', UpgradeProfileItem],
};

const resolveTechSupportProfile = {
    token: 'resolveTechSupportProfile',
    resolveFn: (loadItem, TechSupportProfileItem, auth) => {
        if (auth.isPrivilegeAllowed('PERMISSION_TECHSUPPORTPROFILE')) {
            return loadItem({ id: 'default' }, TechSupportProfileItem);
        }

        return null;
    },
    deps: ['loadItem', TechSupportProfileItem, 'Auth'],
};

const resolveSE = {
    token: 'resolveSE',
    resolveFn: (loadItem, { seId }, Class) => loadItem(seId, Class),
    deps: ['loadItem', '$stateParams', 'ServiceEngine'],
};

const resolveIPReputationDB = {
    token: 'resolveIPReputationDB',
    resolveFn: (defaultValues, loadItem, IPReputationDB) => {
        const ipReputationDBRef = defaultValues.getSystemObjectRefByName(
            'ipreputationdb',
            'System-IPReputation-Webroot-DB',
        );

        return loadItem(ipReputationDBRef.slug(), IPReputationDB);
    },
    // loadedDefaultValues is injected as a dep in order to load it. The resolved value is not
    // actually used.
    deps: ['defaultValues', 'loadItem', 'IPReputationDB', 'loadedDefaultValues'],
};

const resolveClusterInfo = {
    token: 'resolveClusterInfo',
    resolveFn: (loadItem, Cluster) => {
        return loadItem({ id: 'default' }, Cluster);
    },
    deps: ['loadItem', 'Cluster'],
};

const resolveScheduler = {
    token: 'resolveScheduler',
    resolveFn: (defaultValues, loadItem, Scheduler) => {
        const schedulerRef = defaultValues.getSystemObjectRefByName(
            'scheduler',
            'Default-Scheduler',
        );

        return loadItem(schedulerRef.slug(), Scheduler);
    },
    // loadedDefaultValues is injected as a dep in order to load it. The resolved value is not
    // actually used.
    deps: ['defaultValues', 'loadItem', 'Scheduler', 'loadedDefaultValues'],
};

const resolveApplicationSignatureProvider = {
    token: 'resolveApplicationSignatureProvider',
    resolveFn: (defaultValues, loadItem, WafApplicationSignatureProvider, stringService) => {
        const wafApplicationSignatureProviderRef = defaultValues.getSystemObjectRefByName(
            'wafapplicationsignatureprovider',
            'System-WafApplicationSignatures-Trustwave',
        );

        return loadItem(
            stringService.slug(wafApplicationSignatureProviderRef),
            WafApplicationSignatureProvider,
        );
    },
    deps: [
        'defaultValues',
        'loadItem',
        'WafApplicationSignatureProvider',
        'stringService',
        'loadedDefaultValues',
    ],
};

/**
 * @typedef {Object} AppStateData
 * @property {string?} permission
 * @property {boolean?} showTimeframe
 * @property {boolean?} metricsControls
 * @property {boolean?} hasSidebar
 * @property {boolean?} inTenantScope True when state is an Object detail state
 */

/**
 * @typedef {Object} AppState
 * @property {string} name
 * @property {string?} template
 * @property {string?} templateUrl
 * @property {string?} controller
 * @property {string?} component
 * @property {Object?} params
 * @property {string?} title
 * @property {string?} defaultChild
 * @property {boolean?} abstract
 * @property {string} url
 * @property {AppStateData?} data
 * @property {Object[]?} resolve
 * @property {AppState[]?} children
 */

/**
 * Application states list.
 * Used to generated states and privilege map.
 * @type {AppState[]}
 */
const stateTree = [{
    name: 'authenticated.application',
    title: l10nKeys.applicationsTabLabel,
    url: '/applications',
    abstract: true,
    views: {
        nav: {
            component: 'applicationsVerticalNav',
        },
        content: {
            template: '<div ui-view class="application"></div>',
        },
    },
    defaultChild: 'dashboard',
    resolve: [
        angular.extend(
            {},
            loadSystemInfo,
            { policy: { async: 'NOWAIT' } },
        ),
    ],
    children: [
    {
        name: 'dashboard.**',
        url: '/dashboard',
        loadChildren: () => {
            return import('ng/lazy-loaded-modules/applications-dashboard/applications-dashboard.module')
                .then(mod => mod.ApplicationsDashboardModule);
        },
    }, {
        name: 'virtualservice',
        url: '/virtualservice',
        abstract: true,
        template: '<ui-view></ui-view>',
        children: [{
            name: 'virtualservice-list',
            url: '',
            component: VsListPageComponent,
        }, {
            name: 'virtualservice-detail',
            abstract: true,
            url: '/:vsId',
            defaultChild: 'analytics',
            data: {
                inTenantScope: true,
            },
            resolve: [
                resolveVS,
            ],
            views: {
                '@authenticated.application': {
                    component: 'virtualserviceDetail',
                },
            },
            children: [
                {
                    name: 'analytics.**',
                    url: '/analytics?metric&timeframe',
                    loadChildren: () => {
                        return import('ng/lazy-loaded-modules/vs-analytics-page/vs-analytics-page.module')
                            .then(mod => mod.VsAnalyticsPageModule);
                    },
                },
                {
                    component: VsLogsPageComponent,
                    data: {
                        tfGroup: 'logs',
                        hasSidebar: true,
                        showTimeframe: true,
                    },
                    name: 'vs-logs',
                    params: {
                        ...logParamsObject,
                        initFilterParams: {},
                    },
                    url: `/logs?${logParams.join('&')}`,
                },
                angular.copy(insightsStateConfigForVS),
                {
                    name: 'security',
                    url: '',
                    abstract: true,
                    template: '<ui-view></ui-view>',
                    children: [
                        {
                            name: 'security-dashboard.**',
                            url: '/security-dashboard',
                            loadChildren: () => {
                                // eslint-disable-next-line max-len
                                return import('ng/lazy-loaded-modules/vs-security-dashboard-page/vs-security-dashboard-page.module')
                                    .then(mod => mod.VsSecurityDashboardPageModule);
                            },
                        },
                        {
                            name: 'legacy-security',
                            url: '/security?timeframe',
                            data: {
                                showTimeframe: true,
                                hasSidebar: true,
                            },
                            templateUrl: 'src/views/application/virtualservice-security.html',
                        },
                    ],
                },
                {
                    name: 'insights.**',
                    url: '/insights',
                    loadChildren: () => {
                        return import('ng/lazy-loaded-modules/vs-insights-page/vs-insights-page.module')
                            .then(mod => mod.VsInsightsPageModule);
                    },
                },
                getEventListStateConfig(),
                getAlertListStateConfig(),
                {
                    name: 'dns-records',
                    url: '/dns-records?timeframe',
                    component: DnsRecordsPageComponent,
                    data: {
                        showTimeframe: true,
                    },
                }, {
                    name: 'topology.**',
                    url: '/topology?metric&timeframe',
                    loadChildren: () => {
                        return import('ng/lazy-loaded-modules/vs-topology-page/vs-topology-page.module')
                            .then(mod => mod.VsTopologyPageModule);
                    },
                },
            ],
        }],
    }, {
        name: 'vs-vip',
        url: `/vs-vip${listParams}`,
        component: VsVipListPageComponent,
    }, {
        name: 'pool',
        url: '/pool',
        abstract: true,
        template: '<ui-view></ui-view>',
        children: [
            {
                name: 'pool-list.**',
                url: '/pool-list',
                loadChildren: () => {
                    return import('ng/lazy-loaded-modules/pool-list-page/pool-list-page.module')
                        .then(mod => mod.PoolListPageModule);
                },
            },
            {
                name: 'pool-detail',
                url: '/:poolId/:vsId',
                abstract: true,
                // component: 'poolDetail',
                views: {
                    '@authenticated.application': {
                        component: 'poolDetail',
                    },
                },
                defaultChild: 'analytics',
                data: {
                    inTenantScope: true,
                },
                resolve: [
                    resolvePool,
                    resolveVS,
                ],
                children: [
                    {
                        name: 'analytics',
                        url: `/analytics?${['metric', 'timeframe'].join('&')}`,
                        controller: 'PoolAnalyticsController',
                        templateUrl: 'src/views/application/pool-analytics.html',
                        resolve: [
                            loadSystemInfo,
                        ],
                    },
                    getInsightsStateConfig(true),
                    getEventListStateConfig({
                        template: '<events-page></events-page>',
                    }),
                    getAlertListStateConfig({
                        template: '<alerts-page></alerts-page>',
                    }),
                    {
                        name: 'pool-logs.**',
                        url: `/pool-logs?${logParams.join('&')}`,
                        title: globalL10nKeys.logsLabel,
                        loadChildren: () => {
                            return import('ng/lazy-loaded-modules/pool-logs/pool-logs.module')
                                .then(mod => mod.PoolLogsModule);
                        },
                    },
                    {
                        name: 'server',
                        url: '',
                        abstract: true,
                        template: '<ui-view></ui-view>',
                        children: [
                            {
                                name: 'server-list',
                                url: '/servers',
                                templateUrl: 'src/views/application/pool-servers-list.html',
                                controller: 'PoolServerListController',
                            },
                            {
                                name: 'server-detail',
                                url: '/server/:serverId',
                                template: '<div ui-view></div>',
                                abstract: true,
                                defaultChild: 'analytics',
                                data: {
                                    inTenantScope: true,
                                },
                                resolve: [
                                    resolvePoolServer,
                                ],
                                children: [{
                                    name: 'analytics',
                                    url: '/analytics',
                                    templateUrl: 'src/components/applications/server-analytics/' +
                                        'server-analytics.html',
                                    controller: 'ServerAnalyticsController',
                                    resolve: [
                                        loadSystemInfo,
                                    ],
                                }],
                            },
                        ],
                    },
                ],
            },
        ],
    }, {
        name: 'pool-group',
        url: `/pool-group${listParams}`,
        component: PoolGroupListPageComponent,
    }, {
        name: 'gslbservice',
        url: `/gslbservice${listParams}`,
        abstract: true,
        component: 'gslbServiceWrapperPage',
        resolve: [
            resolveGslb,
            loadSystemInfo,
        ],
        children: [{
            name: 'list',
            url: `/list${listParams}`,
            component: 'gslbServiceList',
        }, {
            name: 'gslbservice-detail',
            url: '/:gslbServiceId',
            component: 'gslbServiceDetail',
            abstract: true,
            data: {
                inTenantScope: true,
            },
            resolve: [
                resolveGslbService,
            ],
            children: [{
                name: 'topology.**',
                url: '/topology',
                loadChildren: () => {
                    return import('ng/lazy-loaded-modules/gslb-service-topology-page/gslb-service-topology-page.module')
                        .then(mod => mod.GslbServiceTopologyPageModule);
                },
            }, {
                name: 'members.**',
                url: '/members',
                title: l10nKeys.membersStatusLabel,
                loadChildren: () => {
                    // eslint-disable-next-line max-len
                    return import('ng/lazy-loaded-modules/gslb-service-members-status-page/gslb-service-members-status-page.module')
                        .then(mod => mod.GslbServiceMembersStatusPageModule);
                },
            }, {
                name: 'fqdn-list',
                url: '/fqdn-list',
                component: 'gslbServiceDetailFqdnList',
                title: l10nKeys.fqdnInsightsLabel,
                data: {
                    showTimeframe: true,
                },
            },
            getEventListStateConfig(),
            ],
        }],
    }],
}, {
    name: 'authenticated.operations',
    url: '/operations',
    title: l10nKeys.operationsTabLabel,
    views: {
        nav: {
            component: 'operationsVerticalNav',
        },
        content: {
            template: '<div ui-view class="avi-state-view operations"></div>',
        },
    },
    abstract: true,
    defaultChild: 'alerts.allalerts-list',
    children: [{
        name: 'alerts',
        url: '/alerts',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'allalerts-list',
        children: [
            {
                name: 'allalerts-list',
                url: `/allalerts-list?${commonLogParams.join('&')}`,
                component: AllAlertsListPageComponent,
                data: {
                    permission: 'PERMISSION_ALERT',
                },
            },
            {
                name: 'alertconfig-list',
                url: '/alertconfig',
                component: AlertConfigListPageComponent,
            }, {
                name: 'alertactions-list',
                url: '/alertactions',
                component: AlertActionsListPageComponent,
            }],
    }, {
        name: 'events',
        url: '/events',
        template: '<div ui-view></div>',
        defaultChild: 'events-list',
        abstract: true,
        data: {
            tfGroup: 'logs',
            showTimeframe: true,
        },
        children: [
            getEventListStateConfig({
                name: 'events-list',
                url: `/events-list?${eventParams.join('&')}`,
            }),
            getEventListStateConfig({
                name: 'configuration',
                url: `/configuration?${eventParams.join('&')}`,
            }),
        ],
    }, {
        name: 'services',
        url: '/services',
        template: '<div ui-view class="avi-state-view"></div>',
        defaultChild: 'syslog-list',
        abstract: true,
        children: [{
            name: 'syslog-list',
            url: '/syslog',
            templateUrl: 'src/views/operations/syslog-list.html',
        }, {
            name: 'email-list',
            url: '/email',
            templateUrl: 'src/views/operations/email-list.html',
        }, {
            name: 'snmp-list',
            url: '/snmp',
            component: SnmpTrapListPageComponent,
        }],
    }, {
        name: 'traffic-capture',
        title: l10nKeys.trafficCaptureLabel,
        url: '/traffic-capture',
        templateUrl: 'src/views/operations/traffic-capture.html',
    }, {
        name: 'reports.**',
        url: '/reports',
        loadChildren: () => {
            return import('ng/lazy-loaded-modules/report-page/report-page.module')
                .then(mod => mod.ReportPageModule);
        },
    }],
}, {
    name: 'authenticated.profile',
    url: '/template',
    title: l10nKeys.templatesTabLabel,
    views: {
        nav: {
            component: 'templatesVerticalNav',
        },
        content: {
            template: '<div ui-view class="avi-state-view"</div>',
        },
    },
    abstract: true,
    defaultChild: 'profiles.applicationprofile-list',
    resolve: [
        //to show/hide GSLB monitors tab
        angular.extend(
            {},
            loadSystemInfo,
            { policy: { async: 'NOWAIT' } },
        ),
    ],
    children: [{
        name: 'profiles',
        url: '/profile',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'applicationprofile-list',
        children: [{
            name: 'applicationprofile-list',
            url: '/applicationprofile',
            component: ApplicationProfileListPageComponent,
        }, {
            name: 'networkprofile-list',
            url: '/networkprofile',
            component: NetworkProfilesListPageComponent,
        }, {
            name: 'persistenceprofile-list.**',
            url: '/persistenceprofile',
            loadChildren: () => {
                return import('ng/modules/persistence-profile/persistence-profile.module')
                    .then(mod => mod.PersistenceProfileModule);
            },
        }, {
            name: 'healthmonitor-list',
            url: '/healthmonitor',
            component: HealthMonitorListPageComponent,
            resolve: [
                loadSystemInfo,
            ],
        }, {
            name: 'analyticsprofile-list',
            url: '/analyticsprofile',
            component: AnalyticsProfileListPageComponent,
        }, {
            name: 'ipam-profile',
            url: '/ipam-profile',
            component: IpamDnsProfileListPageComponent,
        }, {
            name: 'custom-ipam-dns',
            url: '/custom-ipam-dns',
            component: CustomIpamDnsProfileListPageComponent,
        }, {
            name: 'traffic-clone-profile',
            url: '/traffic-clone-profile',
            component: TrafficCloneProfilePageComponent,
        }, {
            name: 'icap-profile',
            url: '/icap-profile',
            component: IcapProfileListPageComponent,
        }],
    }, {
        name: 'policy',
        url: '/policy',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'nat-policy-list',
        children: [{
            name: 'nat-policy-list',
            url: '/natpolicy',
            component: NatPolicyListPageComponent,
        }, {
            name: 'l4-policy-set-list',
            url: '/l4policyset',
            component: L4PolicyComponent,
        }, {
            name: 'network-security-policy-list',
            url: '/networksecuritypolicy',
            component: NetworkSecurityPolicyListComponent,
        }, {
            name: 'dns-policy-list',
            url: '/dnspolicy',
            component: DnsPolicyListComponent,
            data: {
                permission: 'PERMISSION_L4POLICYSET',
            },
        }, {
            name: 'http-policy-set-list',
            url: '/httppolicyset',
            component: HTTPPolicySetListComponent,
        }, {
            name: 'application-insights-policy-list.**',
            url: '/applicationinsights',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/application-insights-policy-list-page/application-insights-policy-list-page.module')
                    .then(mod => mod.ApplicationInsightsPolicyListPageModule);
            },
        }, {
            name: 'positive-security-policy-list.**',
            url: '/positive-security-policy',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/positive-security-policy-list-page/positive-security-policy-list-page.module')
                    .then(mod => mod.PositiveSecurityPolicyListPageModule);
            },
        }],
    }, {
        name: 'group',
        url: '/group',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'ipaddrgroup-list',
        children: [{
            name: 'ipaddrgroup-list',
            url: '/ipaddrgroup',
            component: IpAddrGroupListPageComponent,
        }, {
            name: 'stringgroup-list',
            url: '/stringgroup',
            component: StringGroupListComponent,
        }],
    }, {
        name: 'ssl',
        url: '/ssl',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'certificate-list',
        children: [{
            name: 'certificate-list',
            url: '/certificate',
            component: SslCertificateListComponent,
        }, {
            name: 'sslprofile-list',
            url: '/sslprofile',
            component: SslProfileListComponent,
        }, {
            name: 'pkiprofile-list',
            url: '/pkiprofile',
            component: PkiProfileListPageComponent,
        }, {
            name: 'authprofile-list',
            url: '/authprofile',
            component: AuthProfileListPageComponent,
        }, {
            name: 'authmappingprofile-list',
            url: '/authmappingprofile',
            component: AuthMappingProfilePageComponent,
        }, {
            name: 'jwt-server-profile-list',
            url: '/jwtserverprofile',
            component: JwtServerProfileComponent,
        }, {
            name: 'certificate-management-list',
            url: '/certificate-management',
            component: CertificateManagementListPageComponent,
        }, {
            name: 'ip-reputation-list',
            url: '/ip-reputation',
            component: IPReputationDBListPageContainerComponent,
            resolve: [
                loadedPulseRegistrationStatus,
                resolveIPReputationDB,
            ],
        }, {
            name: 'geo-db-list',
            url: '/geodb',
            component: GeoDbListComponent,
        }, {
            name: 'hsmgroup-list',
            url: '/hsmgroup',
            component: HsmGroupListComponent,
        }, {
            name: 'sso-policy-list',
            url: '/ssopolicy',
            component: SSOPolicyListComponent,
        }, {
            name: 'csrf-policy-list',
            url: '/csrfpolicy',
            component: CSRFPolicyListPageComponent,
        }, {
            name: 'trusted-host-profile.**',
            url: '/trustedhostprofile',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/trusted-host-profile/trusted-host-profile.module')
                    .then(mod => mod.TrustedHostProfileModule);
            },
        }],
    }, {
        name: 'scripts',
        url: '/scripts',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'datascriptset-list',
        children: [{
            name: 'datascriptset-list',
            url: '/datascripts',
            component: DataScriptComponent,
        }, {
            name: 'controlscripts-list',
            url: '/controlscripts',
            component: ControlScriptComponent,
        }, {
            name: 'protocol-parser-scripts-list',
            url: '/protocolparserscripts',
            component: ProtocolParserScriptComponent,
        }],
    }, {
        name: 'autoscale',
        url: '/autoscale',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'server-autoscale',
        children: [{
            name: 'server-autoscale',
            url: '/server-autoscale',
            component: ServerAutoScalePolicyListPageComponent,
        }, {
            name: 'launch-config',
            url: '/launch-config',
            component: LaunchConfigListPageComponent,
        }, {
            name: 'webhook',
            url: '/webhook',
            component: WebhookListPageComponent,
        }, {
            name: 'pool-group-deployment-policy',
            url: '/pool-group-deployment-policy',
            component: PoolGroupDeploymentPolicyListPageComponent,
        }],
    }, {
        name: 'waf',
        url: '/waf',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'waf-profile',
        children: [{
            name: 'waf-policy',
            url: '/waf-policy',
            component: WafPolicyListPageComponent,
        }, {
            name: 'waf-profile',
            url: '/waf-profile',
            component: WafProfileListComponent,
        }, {
            name: 'application-rules',
            url: '/application-rules',
            component: WafApplicationRulesListComponent,
            resolve: [
                resolveApplicationSignatureProvider,
            ],
        }, {
            name: 'psm.**',
            url: '/psm',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/waf-positive-security-page/waf-positive-security-page.module')
                    .then(mod => mod.WafPositiveSecurityPageModule);
            },
        }, {
            name: 'waf-crs',
            url: '/waf-crs',
            component: WafCrsListPageComponent,
        }],
    }, {
        name: 'bot',
        url: '/bot',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'bot-management-policy',
        children: [{
            name: 'bot-management-policy-list',
            url: '/bot-management-policy',
            component: BotManagementPolicyListComponent,
        }, {
            name: 'bot-mapping',
            url: '/bot-mapping',
            component: BotMappingPageComponent,
        }],
    }, {
        name: 'error-page',
        url: '/error-page',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'error-page-profile',
        children: [{
            name: 'error-page-profile',
            url: '/error-page-profile',
            component: ErrorPageProfileListComponent,
        }, {
            name: 'error-page-body',
            url: '/error-page-body',
            component: ErrorPageBodyComponent,
        }],
    }, {
        name: 'file-objects.**',
        url: '/file-objects',
        loadChildren: () => {
            return import('ng/lazy-loaded-modules/file-objects-page/file-objects-page.module')
                .then(mod => mod.FileObjectsPageModule);
        },
    }],
}, {
    name: 'authenticated.infrastructure',
    url: '/infrastructure',
    title: l10nKeys.infrastructureTabLabel,
    views: {
        nav: {
            component: 'infrastructureVerticalNav',
        },
        content: {
            template: '<div ui-view class="infrastructure"></div>',
        },
    },
    abstract: true,
    defaultChild: 'dashboard',
    children: [{
        name: 'dashboard',
        url: '/dashboard?timeframe',
        templateUrl: 'src/views/infrastructure/dashboard.html',
        controller: 'InfraDashboardController',
        controllerAs: 'infraDash',
    }, {
        name: 'cloud-list.**',
        url: `/cloud${listParams}`,
        loadChildren: () => {
            return import('ng/lazy-loaded-modules/cloud/cloud-list.module')
                .then(mod => mod.CloudListModule);
        },
    }, {
        name: 'get-started.**',
        url: '/get-started',
        loadChildren: () => {
            // eslint-disable-next-line max-len
            return import('ng/lazy-loaded-modules/infrastructure-get-started-page/infrastructure-get-started-page.module')
                .then(mod => mod.InfrastructureGetStartedPageModule);
        },
    }, {
        name: 'cloud-resources',
        component: 'infrastructureDetail',
        abstract: true,
        url: '/{cloudId}',
        data: {
            inTenantScope: true,
        },
        params: {
            timeframe: {
                value: null,
                dynamic: true,
            },
            cloudId: {
                value: null,
                dynamic: true,
                squash: true,
            },
        },
        resolve: [
            resolveCloud,
        ],
        defaultChild: 'serviceengine',
        children: [{
            name: 'serviceengine',
            url: '/serviceengine',
            component: 'serviceEngineList',
            data: { //displaying: duration and values type
                metricsControls: true,
                showCloudSelector: true,
            },
            children: [{
                name: 'serviceengine-detail',
                url: '/{seId}',
                data: {
                    inTenantScope: true,
                },
                views: {
                    '@authenticated.infrastructure.cloud-resources': {
                        controller: 'ServiceEngineController',
                        template: '<header></header><div ui-view class="serviceengine clearfix"></div>',
                    },
                },
                abstract: true,
                defaultChild: 'summary',
                resolve: [
                    resolveSE,
                ],
                children: [
                    {
                        name: 'summary',
                        url: '/summary?metric&timeframe',
                        templateUrl: 'src/views/infrastructure/se-analytics.html',
                        controller: 'SEAnalyticsController',
                        resolve: [
                            loadSystemInfo,
                        ],
                    },
                    getInsightsStateConfig(true),
                    getEventListStateConfig({
                        template: '<events-page></events-page>',
                    }),
                    {
                        name: 'alerts.**',
                        url: '/alerts',
                        loadChildren: () => {
                            return import('ng/lazy-loaded-modules/se-alert-list-page/se-alert-list-page.module')
                                .then(mod => mod.SeAlertListPageModule);
                        },
                    },
                    {
                        name: 'se-traffic-capture',
                        url: '/se-traffic-capture',
                        defaultChild: 'default',
                        abstract: true,
                        templateUrl: 'src/views/details-leaf-page-template.html',
                        children: [{
                            name: 'default',
                            url: `${listParams}`,
                            views: {
                                '': {
                                    component: TrafficCapturePageComponent,
                                },
                            },
                        }],
                    },
                    {
                        name: 'bgp-peers',
                        url: '/bgp-peers',
                        template: '<bgp-peers-page></bgp-peers-page>',
                    },
                ],
            }],
        }, {
            name: 'segroup-list',
            url: `/segroup/${listParams}`,
            component: SEGroupListPageComponent,
            data: {
                showCloudSelector: true,
            },
        }, {
            name: 'network-list',
            url: `/network/${listParams}`,
            component: NetworkListPageComponent,
            data: {
                showCloudSelector: true,
            },
        }, {
            name: 'network-service-list',
            url: `/network-service/${listParams}`,
            component: 'networkServicesPage',
            data: {
                showCloudSelector: true,
            },
        }, {
            name: 'vrf-context',
            url: `/vrf-context/${listParams}`,
            component: VrfContextPageComponent,
            data: {
                showCloudSelector: true,
            },
        }, {
            name: 'availability-zone.**',
            url: '/availability-zone',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/availability-zone-page/availability-zone-page.module')
                    .then(mod => mod.AvailabilityZonePageModule);
            },
        }],
    }, {
        name: 'gslb',
        url: '/gslb',
        template: '<div ui-view class="avi-state-view"></div>',
        abstract: true,
        defaultChild: 'sites',
        resolve: [
            loadSystemInfo,
        ],
        children: [{
            name: 'sites',
            url: '/sites',
            component: GslbSitesListPageComponent,
            resolve: [
                resolveGslb,
                loadSystemInfo,
            ],
        }, {
            name: 'subdomains',
            url: '/subdomains',
            component: GslbSubdomainsListPageComponent,
            resolve: [
                resolveGslb,
            ],
        }, {
            name: 'geo-profile.**',
            url: '/geo-profile',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/gslb-geo-profile-page/gslb-geo-profile-page.module')
                    .then(mod => mod.GslbGeoProfilePageModule);
            },
        }, {
            name: 'leader-change.**',
            url: '/leader-change',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/gslb-leader-change-page/gslb-leader-change-page.module')
                    .then(mod => mod.GslbLeaderChangePageModule);
            },
        }],
    }],
}, {
    name: 'authenticated.administration',
    url: '/administration',
    title: l10nKeys.administrationTabLabel,
    views: {
        nav: {
            component: 'administrationVerticalNav',
        },
        content: {
            template: '<div ui-view class="avi-state-view administration"></div>',
        },
    },
    abstract: true,
    defaultChild: 'dashboard',
    children: [{
        name: 'users',
        abstract: true,
        url: '/users',
        icon: 'employee',
        title: l10nKeys.accountsLabel,
        template: '<div ui-view class="avi-state-view"></div>',
        defaultChild: 'user-list',
        children: [{
            name: 'user-list',
            title: l10nKeys.usersLabel,
            url: '/user',
            component: UserPageListComponent,
        }, {
            name: 'user-profile-list',
            title: l10nKeys.userProfilesLabel,
            url: '/user-profile',
            component: UserProfileListComponent,
        }, {
            name: 'role-list',
            title: globalL10nKeys.rolesLabel,
            url: '/role',
            component: RoleListPageComponent,
        }, {
            name: 'tenant-list.**',
            url: `/tenant${listParams}`,
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/tenants-page/tenants-page.module')
                    .then(mod => mod.TenantsPageModule);
            },
        }, {
            name: 'tenant-settings',
            title: globalL10nKeys.tenantSettingsLabel,
            url: '/tenant-settings',
            component: TenantSettingsPageListComponent,
        }],
    }, {
        name: 'system-settings.**',
        url: '/system-settings',
        loadChildren: () => {
            return import('ng/lazy-loaded-modules/system-settings-page/system-settings-page.module')
                .then(mod => mod.SystemSettingsPageModule);
        },
    }, {
        name: 'external-services',
        abstract: true,
        url: '/external-services',
        icon: 'line-chart',
        title: l10nKeys.externalServicesLabel,
        template: '<div ui-view class="avi-state-view"></div>',
        defaultChild: 'cloud-services',
        children: [{
            name: 'cloud-services',
            title: l10nKeys.cloudServicesLabel,
            url: '/cloud-services?openRegistrationModal',
            component: CPortalPageComponent,
            resolve: [
                loadSystemInfo,
            ],
            params: {
                openRegistrationModal: {
                    type: 'bool',
                    value: false,
                },
            },
        }, {
            name: 'customer-program',
            title: globalL10nKeys.customerProgramLabel,
            url: '/customer-program',
            component: CustomerProgramComponent,
        }],
    }, {
        name: 'licensing',
        url: '/licensing',
        icon: 'certificate',
        title: l10nKeys.licensingLabel,
        component: LicensingPageComponent,
        resolve: [
            loadedSystemConfigService,
        ],
    }, {
        name: 'controller-detail',
        abstract: true,
        url: '/controller',
        icon: 'atom',
        title: globalL10nKeys.controllerLabel,
        template: '<div ui-view class="avi-state-view controller-detail"></div>',
        defaultChild: 'cluster',
        children: [{
            name: 'cluster',
            title: l10nKeys.nodesLabel,
            url: '/cluster',
            component: NodesPageComponent,
            resolve: [
                resolveClusterInfo,
            ],
        }, {
            name: 'software',
            title: l10nKeys.softwareLabel,
            url: '/software',
            component: 'softwarePage',
        },
        {
            name: 'update',
            url: '/update',
            title: l10nKeys.updateLabel,
            component: UpdatePageComponent,
            abstract: true,
            resolve: [
                loadedSystemConfigService,
                resolveUpgradeProfile,
            ],
            children: [{
                name: 'system',
                title: l10nKeys.systemUpdateLabel,
                url: '/system',
                component: SystemUpdateComponent,
            },
            {
                name: 'seg',
                title: l10nKeys.segUpdateLabel,
                url: '/seg',
                component: SegUpdatePageComponent,
            }],
        },
        {
            name: 'upload-hsm-packages',
            title: l10nKeys.uploadHsmPackagesLabel,
            url: '/upload-hsm-packages',
            component: UploadHsmPackagesPageComponent,
        }, {
            name: 'backup',
            title: l10nKeys.configurationBackupLabel,
            url: '/backup',
            component: BackupPageComponent,
            resolve: [
                resolveScheduler,
            ],
        }, {
            name: 'reports.**',
            title: l10nKeys.reportsLabel,
            url: '/reports',
            loadChildren: () => {
                return import('ng/lazy-loaded-modules/system-reports-page/system-reports-page.module')
                    .then(mod => mod.SystemReportsPageModule);
            },
        }],
    }, {
        name: 'user-credentials',
        url: '/user-credentials',
        icon: 'id-badge',
        title: l10nKeys.userCredentialsLabel,
        component: UserCredentialsListPageComponent,
    }, {
        name: 'support',
        abstract: true,
        url: '/support',
        icon: 'help',
        title: l10nKeys.supportLabel,
        template: '<div ui-view class="avi-state-view"></div>',
        defaultChild: 'techsupport',
        children: [{
            name: 'techsupport',
            title: l10nKeys.techSupportLabel,
            url: '/techsupport',
            component: TechSupportListPageComponent,
            resolve: [
                loadedPulseRegistrationStatus,
                resolveTechSupportProfile,
            ],
            children: [{
                name: 'tech-support-detail.**',
                title: l10nKeys.reportsLabel,
                url: '/tech-support-detail',
                loadChildren: () => {
                    return import('ng/lazy-loaded-modules/tech-support-report-page/tech-support-report-page.module')
                        .then(mod => mod.TechSupportReportPageModule);
                },
            }],
        }, {
            name: 'crashreports',
            title: l10nKeys.crashReportsLabel,
            url: '/crashreports',
            component: CrashReportsPageComponent,
        }],
    }, {
        name: 'dashboard.**',
        url: '/dashboard',
        loadChildren: () => {
            return import('ng/modules/administration-dashboard/administration-dashboard.module')
                .then(mod => mod.AdministrationDashboardModule);
        },
    }],
}];

/**
 * Sets fullName for a state and its children.
 * @param {AppState} state
 * @param {string} parentPath
 * @inner
 */
function setFullName(state, parentPath) {
    const {
        name: stateName,
        children: childStates = [],
    } = state;

    const fullPath = parentPath ? `${parentPath}.${stateName}` : stateName;

    setFullNameProperty(state, fullPath);

    if (childStates.length) {
        childStates.forEach(childState => setFullName(childState, fullPath));
    }
}

/**
 * Sets fullName property in a given state.
 * @param {AppState} state
 * @param {string} fullName
 * @inner
 */
function setFullNameProperty(state, fullName) {
    state.fullName = fullName;
}

stateTree.forEach(state => setFullName(state));

/**
 * @ngdoc constant
 * @name appStateTree
 * @description
 *      Array containing all the static routes with name, url and permission details.
 * @author Aravindh Nagarajan
 */
export const appStateTree = stateTree;
